<template>
  <div class="gc-header-form-split-container gc-header-form">
    <div class="gc-header-toolbar">
      <gc-form-header-toolbar
        :toolbar-options="
          getHeaderToolbar
            ? getHeaderToolbar.headerToolbar
            : headerOptions.headerToolbar
        "
        :data-model="data"
        :itemSaveCallBack="checkHeaderFormValidation"
        :backRoute="backButtonRoute"
        :setLoading="setLoading"
        ref="gc-form-header-toolbar"
        :baseView="baseView"
      ></gc-form-header-toolbar>
    </div>
    <div>
      <div class="header-form-container">
        <div class="header-form">
          <div class="view-card responsive-paddings">
            <gc-form
              v-if="headerOptions.formItems"
              :formOptions="headerFormOptions"
              :formItems="headerOptions.formItems"
              :isNormal="true"
              :data-model="data"
              :deliveryAddressClicked="showDeliveryAddress"
              :formMode="baseView.mode"
              :fromFrom="'gc-header-form'"
              ref="gc-header-form"
              :valueChangeCallBack="valueChangeCallBack"
              :checkValid="isValid"
              :validationGroup="'gc-header-form'"
              :scrollingEnabled="false"
              :formContentReady="onHeaderFormContentReady"
            ></gc-form>
          </div>
        </div>
        <div class="header-comments">
          <div class="view-card responsive-paddings">
            <gc-form
              v-if="headerOptions.formItems"
              :formOptions="headerFormOptions"
              :formItems="commentPopUpItems"
              :isNormal="true"
              :data-model="data"
              :deliveryAddressClicked="undefined"
              :formMode="baseView.mode"
              :fromFrom="'gc-header-comments'"
              ref="gc-header-comments"
              :validationGroup="'gc-header-comments'"
              :scrollingEnabled="true"
              :formHeight="headerDxFormHeight"
              :headerUpdateOff="true"
            ></gc-form>
          </div>
        </div>
      </div>
    </div>

    <gc-popup
      :popup-visible="editDeliveryAddressVisible"
      popup-title="Deliver To"
      :back-button-function="closeDeliveryAddressPopup"
      :popup-height="360"
      :saveButtonConfig="deliveryAddressPopupConfig.save"
      :backButtonConfig="deliveryAddressPopupConfig.back"
      :wrapperAttr="{ class: 'css-v2 gc-popup' }"
    >
      <div class="css-v2 gc-popup-form">
        <gc-form
          :formOptions="deliveryAddressFormOptions"
          :formItems="headerOptions.deliveryAddressItems"
          :isNormal="true"
          :data-model="getFormDataModel"
          :formMode="baseView.mode"
          :formKey="formKey"
          :fromFrom="'gc-header-form-d-a'"
        ></gc-form>
      </div>
    </gc-popup>
  </div>
</template>

<script>
function logDev() {
  // eslint-disable-next-line no-console
  console.log("CX LOG >>> ", ...arguments);
}

import RouteMixin from "../_mixins/route.mixin";
import FormMixin from "@/_mixins/form.mixin";
import { mapGetters } from "vuex";

export default {
  mixins: [RouteMixin, FormMixin],
  created() {},
  data() {
    return {
      headerFormOptions: {
        gcLabelLocation: "left",
      },
      editDeliveryAddressVisible: false,
      deliveryAddressFormOptions: {
        gcLabelLocation: "left",
      },
      formKey: "1",
      addressData: undefined,
      isValid: false,
      originalModel: undefined,
      headerDxFormHeight: "auto",
    };
  },
  props: {
    formContentReady: {
      type: Function,
      default: () => {},
    },
    setLoading: {
      type: Function,
      default: () => {},
    },
    headerOptions: {
      type: Object,
      default: () => {},
    },
    data: {
      type: Object,
      default: () => {},
    },
    saveTransaction: {
      type: Function,
      default: () => {},
    },
    backButtonRoute: {
      type: String,
      default: undefined,
    },
    getHeaderToolbar: {
      type: Object,
      default: () => {},
    },
  },
  methods: {
    onHeaderFormContentReady(e) {
      this.formContentReady(e);

      this.headerDxFormHeight = e.element.offsetHeight;
    },
    showDeliveryAddress(item) {
      this.addressData = undefined;
      this.originalModel = item;

      this.addressData = {
        DeliveryAddressCompanyName: item.DeliveryAddressCompanyName,
        DeliveryAddressCountry: item.DeliveryAddressCountry,
        DeliveryAddressPostcode: item.DeliveryAddressPostcode,
        DeliveryAddressState: item.DeliveryAddressState,
        DeliveryAddressStreetLine1: item.DeliveryAddressStreetLine1,
        DeliveryAddressStreetLine2: item.DeliveryAddressStreetLine2,
        DeliveryAddressSuburb: item.DeliveryAddressSuburb,
      };

      logDev("showDeliveryAddress", this.addressData);
      this.formKey = Math.random().toString(36).substring(7);
      this.editDeliveryAddressVisible = true;
    },
    closeDeliveryAddressPopup() {
      this.editDeliveryAddressVisible = false;
    },
    updateDeliveryAddress() {
      this.editDeliveryAddressVisible = false;
      var items = this.$refs["gc-header-form"].$refs[
        "gc-form-comp"
      ].instance.getEditor("DeliveryAddressCompanyName");

      var DeliverTo =
        this.$refs["gc-header-form"].$refs["gc-form-comp"].instance.getEditor(
          "DeliverTo"
        );

      if (items) items.option("value", this.data.DeliveryAddressCompanyName);
      if (DeliverTo) DeliverTo.repaint();

      this.originalModel.DeliveryAddressCompanyName =
        this.addressData.DeliveryAddressCompanyName;
      this.originalModel.DeliveryAddressStreetLine1 =
        this.addressData.DeliveryAddressStreetLine1;
      this.originalModel.DeliveryAddressStreetLine2 =
        this.addressData.DeliveryAddressStreetLine2;
      this.originalModel.DeliveryAddressSuburb =
        this.addressData.DeliveryAddressSuburb;
      this.originalModel.DeliveryAddressState =
        this.addressData.DeliveryAddressState;
      this.originalModel.DeliveryAddressPostcode =
        this.addressData.DeliveryAddressPostcode;
      this.originalModel.DeliveryAddressCountry =
        this.addressData.DeliveryAddressCountry;
    },
    checkHeaderFormValidation(isValid, brokenRules) {
      if (!isValid) this.saveTransaction(isValid, brokenRules);
      else {
        if (!this.headerOptions.formItems)
          this.saveTransaction(isValid, brokenRules);
        else this.isValid = true;
      }
    },
    async valueChangeCallBack(isValid, brokenRules) {
      this.isValid = false;
      if (this.commentPopUpItems) {
        const mainForm = await this.$refs["gc-header-comments"].getFormValidations();
        this.saveTransaction(mainForm.isValid, mainForm.brokenRules);
      } else this.saveTransaction(isValid, brokenRules);
    },
  },
  computed: {
    ...mapGetters({ commentPopUpItems: "ui/getCommentPopUpItems" }),
    ...mapGetters({ gridExpand: "ui/getGridExpand" }),
    getFormDataModel() {
      return this.addressData;
    },
    deliveryAddressFormIsDirty() {
      if (!this.originalModel) return false;

      return (
        this.originalModel.DeliveryAddressCompanyName !==
          this.addressData.DeliveryAddressCompanyName ||
        this.originalModel.DeliveryAddressStreetLine1 !==
          this.addressData.DeliveryAddressStreetLine1 ||
        this.originalModel.DeliveryAddressStreetLine2 !==
          this.addressData.DeliveryAddressStreetLine2 ||
        this.originalModel.DeliveryAddressSuburb !==
          this.addressData.DeliveryAddressSuburb ||
        this.originalModel.DeliveryAddressState !==
          this.addressData.DeliveryAddressState ||
        this.originalModel.DeliveryAddressPostcode !==
          this.addressData.DeliveryAddressPostcode ||
        this.originalModel.DeliveryAddressCountry !==
          this.addressData.DeliveryAddressCountry
      );
    },
    deliveryAddressPopupConfig() {
      return {
        save: {
          text: "Save",
          disabled: !this.deliveryAddressFormIsDirty,
          clickCallback: async () => {
            await this.updateDeliveryAddress();
          },
        },
        back: {
          text: "Cancel",
          clickCallback: async () => {
            this.closeDeliveryAddressPopup();
          },
        },
      };
    },
  },
};
</script>

<style scoped lang="scss">
.gc-header-form-split-container {
  .gc-header-toolbar {
    padding-bottom: 0;
  }
  .view-card {
    -webkit-box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12),
      0 1px 2px rgba(0, 0, 0, 0.24);
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
    background-color: #fff;
    margin: 2px 0px 3px;
  }

  .responsive-paddings {
    padding: 20px;
  }

  .dx-scrollview-content .content .view-card.responsive-paddings {
    -webkit-box-shadow: none;
    box-shadow: none;
  }

  .gc-header-form {
    .view-card.responsive-paddings {
      padding: 12px !important;
    }
  }
  .header-form-container {
    width: 100%;
    display: inline-flex;

    .header-form {
      width: calc((100% / 3) * 2);
      padding-right: 5px;
      margin-bottom: 0 !important;
    }

    .header-comments {
      width: calc((100% / 3) * 1);
      padding-left: 5px;
    }
  }
}
</style>
